export default __webpack_public_path__ + "img/history.b73dd819.webp";